import request from 'utils/request';

export function changeBranch(branchCode: string, data: string[]) {
    return request('/kazpension/change-branch', {
        method: 'POST',
        params: { branchCode },
        data,
    });
}
